import React from "react";
import { Navigate, Outlet, useNavigate, useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
import { adminRoutes, publicRoutes } from "./routes";
import {
  getRoleBasePath,
  getRoleHomePath,
  normalizeRoutePath,
} from "./utils/roleRoutes";

export default function ProtectedOutlet() {
  const isLoggedIn = useSelector((state) => state.login.isLoggedIn);
  if (isLoggedIn) {
    return <Outlet />;
  } else {
    return <Navigate to="/signin" />;
  }
}


export const ProtectedRoute = () => {
  const { data } = useSelector((state) => state.login);
  const location = useLocation();

  // 1. Not logged in
  if (!data?.accessToken) {
    return <Navigate to="/signin" replace />;
  }

  const userRole = String(data?.role || "").toUpperCase(); // "ADMIN" | "DOCTOR" | "PROVIDER"
  const basePath = getRoleBasePath(userRole);
  const pathname = location.pathname;

  // 2. Role hi unknown hai -> unauthorized
  if (!basePath) {
    return <Navigate to="/unauthorized" replace />;
  }

  // 3. Doosre role ke area me hai -> apne dashboard par bhej do
  if (pathname !== basePath && !pathname.startsWith(`${basePath}/`)) {
    return <Navigate to={`${basePath}/dashboard`} replace />;
  }

  // 4. Route config me match karo (config me path relative hai, jaise "dashboard")
  const relativePath = normalizeRoutePath(pathname.slice(basePath.length));
  const matchedRoute = adminRoutes.find((route) => {
    const routePath = normalizeRoutePath(route.path);
    return routePath !== "*" && routePath === relativePath;
  });

  // 5. Us route ke liye permission check
  const isAllowed =
    !matchedRoute ||
    (matchedRoute.allowedRoles || []).some((allowedRole) => {
      const normalized = String(allowedRole).toUpperCase();
      return normalized === "ALL" || normalized === userRole;
    });

  if (!isAllowed) {
    return <Navigate to="/unauthorized" replace />;
  }

  return <Outlet />;
};



export function PublicOutlet() {
  const navigate = useNavigate();
  const location = useLocation();
  const isLoggedIn = useSelector((state) => state.login.isLoggedIn);
  const { data } = useSelector((state) => state.login);

  React.useEffect(() => {
    const homePath = isLoggedIn ? getRoleHomePath(data?.role) : null;
    if (homePath) {
      navigate(homePath, { replace: true });
    }
  }, [isLoggedIn, data?.role, navigate, location]);

  return <Outlet />;
}

export function LoggedInOutlet() {
  const isLoggedIn = useSelector((state) => state.login.isLoggedIn);
  return isLoggedIn ? <Navigate to="/" /> : <Outlet />;
}
